import Link from '@tiptap/extension-link';

const LinkExtension = Link.configure({ autolink: true, linkOnPaste: true });

export default LinkExtension;
